import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";

export interface AgentTokenResource {
  token: string;
}

@Injectable({
  providedIn: 'root'
})
export class AgentAccessService {
  constructor(private readonly http: HttpClient) {
  }

  generateToken() {
    return this.http.post<AgentTokenResource>(`${environment.API_URL}/api/admin/agent/token`, {});
  }
}
